import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import routes from '../../common/routes/home/client-routes'
import PCLNAnalytics from '@pcln/analytics'
import { initializePclnExpt, clearBatch } from '../helpers/initialize-pcln-expt'
import packageJson from '../../../package.json'
import { BootstrapDataContext, ExperimentContext } from '../../common/contexts'

initializePclnExpt('DESKTOPWEB', 16)

const bootstrapData = window.PCLN_BOOTSTRAP_DATA || {}
const bootstrapSETI = bootstrapData.seti || {}

const BrowserRouterComponent = () => (
  <BrowserRouter>
    <BootstrapDataContext.Provider value={bootstrapData}>
      <ExperimentContext.Provider value={bootstrapSETI}>
        <Switch>{renderRoutes(routes())}</Switch>
      </ExperimentContext.Provider>
    </BootstrapDataContext.Provider>
  </BrowserRouter>
)

ReactDOM.hydrate(
  <BrowserRouterComponent />,
  document.querySelector('#pcln-app')
)

window.onbeforeunload = function (e) {
  clearBatch()
}

const errorHandler = (
  message,
  source = null,
  lineNo = null,
  columnNo = null,
  error = {}
) => {
  PCLNAnalytics.appName = packageJson.name
  PCLNAnalytics.appVersion = packageJson.version
  PCLNAnalytics.logError({
    category: 'FrontEndException',
    message:
      message.toLowerCase().indexOf('script error') < 0
        ? error.message
        : 'unknown',
    error:
      message.toLowerCase().indexOf('script error') < 0
        ? error.error
        : 'External script error',
    stack:
      message.toLowerCase().indexOf('script error') < 0
        ? error.stack
        : 'unknown',
    cguid: window.PCLN_BOOTSTRAP_DATA.webstats.clientGUID,
    platform: 'Desktop',
    product: 'Home',
    columnNo,
    lineNo,
    source
  })
}

window.onerror = errorHandler
